import React from 'react';
import { Check, Building2, Layers, FileCheck, Route, Zap } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PayerWizardStepIndicatorProps {
  currentStep: number;
  completedSteps: boolean[];
}

const STEPS = [
  { number: 1, label: 'Payer Setup', icon: Building2 },
  { number: 2, label: 'Plan Setup', icon: Layers },
  { number: 3, label: 'Rule Review', icon: FileCheck },
  { number: 4, label: 'Lane Config', icon: Route },
  { number: 5, label: 'Activate', icon: Zap },
];

export function PayerWizardStepIndicator({ currentStep, completedSteps }: PayerWizardStepIndicatorProps) {
  return (
    <div className="flex items-center justify-between w-full max-w-3xl mx-auto mb-8">
      {STEPS.map((step, index) => {
        const isComplete = completedSteps[index];
        const isCurrent = currentStep === step.number;
        const isPast = currentStep > step.number;
        const Icon = step.icon;
        
        return (
          <React.Fragment key={step.number}>
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  'w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all',
                  isComplete && 'bg-primary border-primary text-primary-foreground',
                  isCurrent && !isComplete && 'border-primary text-primary bg-primary/10',
                  !isComplete && !isCurrent && 'border-muted-foreground/30 text-muted-foreground'
                )}
              >
                {isComplete ? (
                  <Check className="h-5 w-5" />
                ) : (
                  <Icon className="h-5 w-5" />
                )}
              </div>
              <span
                className={cn(
                  'text-xs mt-2 font-medium',
                  isCurrent && 'text-primary',
                  isComplete && 'text-primary',
                  !isComplete && !isCurrent && 'text-muted-foreground'
                )}
              >
                {step.label}
              </span>
            </div>
            
            {index < STEPS.length - 1 && (
              <div
                className={cn(
                  'flex-1 h-0.5 mx-2',
                  isPast || isComplete ? 'bg-primary' : 'bg-muted-foreground/30'
                )}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
